















import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import dialogComp from "@/components/dialog/index.vue";
import { Button } from "mint-ui";
import loginDialog from "../login/index";
import giftDialog from "../gift/index";
import uploadDialog from '../upload/index'
import qs from 'qs'
@Component<VBANNER>({
  components: {
    dialogComp,
    "mt-button": Button,
  },
})
export default class VBANNER extends Vue {
  public tipType: string = ""; /* 0是已参与过活动，1是未中奖 */
  public tipError: string = "";
  public params: any = {
    name: "",
    phone: "",
    addr: "",
  };
  public show() {
    (this.$refs.dialog as any).show();
  }
  public close() {
    (this.$refs.dialog as any).close();
  }
  public showUpload(){
    uploadDialog()
  }
  public goUrl() {
    location.href =
      "https://m.flight.qunar.com/shark/active/fee0bf1f71746f144087b2013257a9e0?activityNo=bmhq&bdsource=bmhq&giftId=bmhq";
  }
  public submit() {
    (this as any).$http({
      url: "/linke/rePrzie?"+qs.stringify(this.params),
      type: "get",
      config: { formType: true },
      login: loginDialog,
      success: (res: any) => {
        (this as any).$dialog.alert({
          message: "提交成功",
        });
      },
    });
  }
  public callback() {}
  public goLottery() {
    this.callback();
    this.close();
  }
}
